import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TransformerManagerService = /** @class */ (function () {
    function TransformerManagerService(http) {
        this.http = http;
    }
    TransformerManagerService.prototype.saveTransformerData = function (data) {
        var payload = data;
        return this.http.post('addUpdateTransformer', payload);
    };
    TransformerManagerService.prototype.saveEMSData = function (data) {
        return this.http.post('addUpdateEnergyMeter', data);
    };
    TransformerManagerService.prototype.getTransformerData = function (roleid, userid, module) {
        return this.http.get("getTransformerData?roleid=" + roleid + "&userid=" + userid + "&module=" + module);
    };
    TransformerManagerService.prototype.getEnergyMeters = function (deviceid) {
        return this.http.get('getEnergyMeters?deviceid=' + deviceid);
    };
    TransformerManagerService.prototype.getEnergyMeterReportData = function (data) {
        return this.http.post('getEnergyMeterReportData', data);
    };
    TransformerManagerService.prototype.getEnergyMeterData = function (roleid, userid, module) {
        return this.http.get("getEnergyMeterData?roleid=" + roleid + "&userid=" + userid + "&module=" + module);
    };
    TransformerManagerService.prototype.getDeviceDdl = function () {
        return this.http.get('getDeviceDdl');
    };
    TransformerManagerService.prototype.getModelHtml = function () {
        return this.http.get("digitaltwin", { responseType: 'text' });
    };
    TransformerManagerService.prototype.getTransformerDetails = function (data) {
        console.log('DATA:', data);
        return this.http.get("getTransformerDetails?transformerId=" + data.transformerId + "&deletedFlag=" + data.deletedFlag);
    };
    TransformerManagerService.prototype.getEnergyMeterDetails = function (data) {
        console.log('DATA:', data);
        return this.http.get("getEnergyMeterDetails?energyMeterId=" + data.energyMeterId + "&deletedFlag=" + data.deletedFlag);
    };
    TransformerManagerService.prototype.deleteTransformer = function (data) {
        var payload = data;
        return this.http.post('deleteTransformer', payload);
    };
    TransformerManagerService.prototype.getThresholdValue = function (payload) {
        return this.http.post('getThresholdValue', payload);
    };
    TransformerManagerService.prototype.saveMaintaianceData = function (data) {
        return this.http.post('saveMaintainancePlanningData', data);
    };
    TransformerManagerService.prototype.getMaintenancePlanningData = function (data) {
        return this.http.post('getMaintenancePlanningData', data);
    };
    TransformerManagerService.prototype.getMaintenanceParameters = function () {
        return this.http.get('getMaintenanceParameters');
    };
    TransformerManagerService.prototype.deleteMaintenancePlanningData = function (data) {
        return this.http.post('deleteMaintenancePlanningData', data);
    };
    TransformerManagerService.prototype.addResolution = function (data) {
        return this.http.post('addResolutionData', data);
    };
    TransformerManagerService.prototype.getResolutionData = function (data) {
        return this.http.post('getResolutionData', data);
    };
    TransformerManagerService.prototype.deleteMaintenancePlanningResolutionData = function (data) {
        return this.http.post('deleteMaintenancePlanningResolutionData', data);
    };
    TransformerManagerService.prototype.pfPenalty = function (requestData) {
        console.log(' requestData:', requestData);
        return this.http.post("pfPenalty", requestData);
    };
    TransformerManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransformerManagerService_Factory() { return new TransformerManagerService(i0.ɵɵinject(i1.HttpClient)); }, token: TransformerManagerService, providedIn: "root" });
    return TransformerManagerService;
}());
export { TransformerManagerService };
